import React from "react";
import PropTypes from "prop-types";
import kebabCase from "lodash-es/kebabCase";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import PermissionButton from "components/PermissionButton";

import Typography from "ui/Typography";

export const ErrorContainer = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        padding: "4px 0 0px 0",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "4px",
        flex: "1 0 0",
        alignSelf: "stretch",
      }}
    >
      {children}
    </Box>
  );
};

ErrorContainer.propTypes = {
  children: PropTypes.element,
};

const Error = (props) => {
  const { Icon, title, subTitle, buttonProps, secondaryButtonProps } = props;

  const renderButton = () => {
    if (!buttonProps && !secondaryButtonProps) return;

    return (
      <Stack gap="8px" direction="row">
        {buttonProps && (
          <PermissionButton
            id={`${kebabCase(buttonProps.title)}-permission-button`}
            onClick={buttonProps.onClick}
            permission={buttonProps.permission}
          >
            {buttonProps.title}
          </PermissionButton>
        )}
        {secondaryButtonProps && (
          <PermissionButton
            id={`${kebabCase(secondaryButtonProps.title)}-permission-button`}
            onClick={secondaryButtonProps.onClick}
            permission={secondaryButtonProps.permission}
            variant="text"
          >
            {secondaryButtonProps.title}
          </PermissionButton>
        )}
      </Stack>
    );
  };

  return (
    <Stack width="320px" gap="24px" alignItems="center">
      <Stack gap="16px" alignItems="center">
        {Icon && <Icon width="56px" height="56px" color="#E0E2EC" />}
        <Stack
          gap="8px"
          alignItems="center"
          alignSelf="stretch"
          textAlign="center"
        >
          <Typography variant="h6">{title}</Typography>
          <Typography>{subTitle}</Typography>
        </Stack>
      </Stack>
      {renderButton()}
    </Stack>
  );
};

Error.propTypes = {
  Icon: PropTypes.any,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  buttonProps: PropTypes.shape({
    title: PropTypes.string,
    onClick: PropTypes.func,
    permission: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  }),
  secondaryButtonProps: PropTypes.shape({
    title: PropTypes.string,
    onClick: PropTypes.func,
    permission: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  }),
};

export default Error;
